// extracted by mini-css-extract-plugin
export var container__title = "FeaturedCafetera-module--container__title--9f7ec";
export var img = "FeaturedCafetera-module--img--9a750";
export var imgBase = "FeaturedCafetera-module--imgBase--91e16";
export var imgHovered = "FeaturedCafetera-module--imgHovered--1378b";
export var imgNotHovered = "FeaturedCafetera-module--imgNotHovered--47be6";
export var img__container = "FeaturedCafetera-module--img__container--dbc6d";